import React from 'react';
import { TextField, Box, InputAdornment } from '@mui/material';

interface NumberSearchInputProps {
  field: string;
  value: number | null;
  onChange: (value: number | null) => void;
  placeholder?: string;
}

export const NumberSearchInput: React.FC<NumberSearchInputProps> = ({
  field,
  value,
  onChange,
  placeholder
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    
    if (inputValue === '') {
      onChange(null);
    } else {
      const numericValue = parseFloat(inputValue);
      if (!isNaN(numericValue)) {
        onChange(numericValue);
      }
    }
  };

  const handleClear = () => {
    onChange(null);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TextField
        fullWidth
        size="small"
        type="number"
        label={placeholder || field}
        placeholder="Search"
        value={value || ''}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: value !== null && (
            <InputAdornment position="end">
              <Box
                component="span"
                onClick={handleClear}
                sx={{
                  cursor: 'pointer',
                  color: 'text.secondary',
                  '&:hover': { color: 'text.primary' }
                }}
              >
                ✕
              </Box>
            </InputAdornment>
          )
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '0.8125rem',
            py: 0.75,
          },
          '& .MuiInputBase-input::placeholder': {
            fontSize: '0.78rem',
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.75rem',
            fontWeight: 600,
          },
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: 'primary.main',
            },
          },
        }}
      />
    </Box>
  );
};
